
export const dsConstants = {
    LOAD_COLUMNS_REQUEST: 'LOAD_COLUMNS_REQUEST', 
    LOAD_COLUMNS_SUCCESS: 'LOAD_COLUMNS_SUCCESS',
    LOAD_COLUMNS_FAILURE: 'LOAD_COLUMNS_FAILURE',

    CLEAR_COLUMNS: 'CLEAR_COLUMNS',

    EDIT_SINGLE_REQUEST: 'EDIT_SINGLE_REQUEST',
    EDIT_SINGLE_SUCCESS: 'EDIT_SINGLE_SUCCESS',
    EDIT_SINGLE_FAILURE: 'EDIT_SINGLE_FAILURE',
    EDIT_SINGLE_DELETE_TRACKER: 'EDIT_SINGLE_DELETE_TRACKER',

    DELETE_SINGLE_REQUEST: 'DELETE_SINGLE_REQUEST',
    DELETE_SINGLE_SUCCESS: 'DELETE_SINGLE_SUCCESS',
    DELETE_SINGLE_FAILURE: 'DELETE_SINGLE_FAILURE',
    DELETE_SINGLE_DELETE_TRACKER: 'DELETE_SINGLE_DELETE_TRACKER',

    DELETE_MANY_REQUEST: 'DELETE_MANY_REQUEST', 
    DELETE_MANY_SUCCESS: 'DELETE_MANY_SUCCESS', 
    DELETE_MANY_FAILURE: 'DELETE_MANY_FAILURE',
    DELETE_MANY_DELETE_TRACKER: 'DELETE_MANY_DELETE_TRACKER', 

    DOWNLOAD_XLSX_REQUEST: 'DOWNLOAD_XLSX_REQUEST',
    DOWNLOAD_XLSX_SUCCESS: 'DOWNLOAD_XLSX_SUCCESS',
    DOWNLOAD_XLSX_FAILURE: 'DOWNLOAD_XLSX_FAILURE',

    SET_ROW_ADD_TRACKER: 'SET_ROW_ADD_TRACKER',
    ROW_ADD_SUCCESS: 'ROW_ADD_SUCCESS',
    ROW_ADD_FAILURE: 'ROW_ADD_FAILURE',
    CLEAR_ROW_ADD_TRACKER: 'CLEAR_ROW_ADD_TRACKER',

    SET_VIEW_DEFS_REQUEST: 'SET_VIEW_DEFS_REQUEST',
    SET_VIEW_DEFS_SUCCESS: 'SET_VIEW_DEFS_SUCCESS',
    SET_VIEW_DEFS_FAILURE: 'SET_VIEW_DEFS_FAILURE',
    CLEAR_VIEW_DEFS_TRACER: 'CLEAR_VIEW_DEFS_TRACKER',

    JIRA_REFRESH_REQUEST: 'JIRA_REFRESH_REQUEST',
    JIRA_REFRESH_SUCCESS: 'JIRA_REFRESH_SUCCESS',
    JIRA_REFRESH_FAILURE: 'JIRA_REFRESH_FAILURE',
    JIRA_REFRESH_DELETE_TRACKER: 'JIRA_REFRESH_DELETE_TRACKER',

    ADD_FILTER_REQUEST: 'ADD_FILTER_REQUEST',
    ADD_FILTER_SUCCESS: 'ADD_FILTER_SUCCESS',
    ADD_FILTER__FAILURE: 'ADD_FILTER__FAILURE',
    CLEAR_ADD_FILTER_TRACKER: 'CLEAR_ADD_FILTER_TRACKER',

    EDIT_FILTER_REQUEST: 'EDIT_FILTER_REQUEST',
    EDIT_FILTER_SUCCESS: 'EDIT_FILTER_SUCCESS',
    EDIT_FILTER__FAILURE: 'EDIT_FILTER__FAILURE',
    CLEAR_EDIT_FILTER_TRACKER: 'CLEAR_EDIT_FILTER_TRACKER',

    DELETE_FILTER_REQUEST: 'DELETE_FILTER_REQUEST',
    DELETE_FILTER_SUCCESS: 'DELETE_FILTER_SUCCESS',
    DELETE_FILTER__FAILURE: 'DELETE_FILTER__FAILURE',
    CLEAR_DELETE_FILTER_TRACKER: 'CLEAR_DELETE_FILTER_TRACKER',

    CLEAR_DS: 'CLEAR_DS',
    UPLOAD_BULK_XLS_REQUEST: 'UPLOAD_BULK_XLS_REQUEST', 
    UPLOAD_BULK_XLS_SUCCESS: 'UPLOAD_BULK_XLS_SUCCESS',
    UPLOAD_BULK_XLS_FAILURE: 'UPLOAD_BULK_XLS_FAILURE',
    SET_BULK_SELECTED_SHEET: 'SET_BULK_SELECTED_SHEET',
    LOAD_BULK_FROM_RANGE_REQUEST: 'LOAD_BULK_FROM_RANGE_REQUEST',
    LOAD_BULK_FROM_RANGE_SUCCESS: 'LOAD_BULK_FROM_RANGE_SUCCESS',
    LOAD_BULK_FROM_RANGE_FAILURE: 'LOAD_BULK_FROM_RANGE_FAILURE',
    DELETE_COLUMN_REQUEST : "DELETE_COLUMN_REQUEST",
    DELETE_COLUMN_SUCCESS : "DELETE_COLUMN_SUCCESS",
    DELETE_COLUMN_FAILURE : "DELETE_COLUMN_FAILURE",
    CLEAR_DELETE_COLUMN_TRACKER : "CLEAR_DELETE_COLUMN_TRACKER",
    ADD_COLUMN_REQUEST : "ADD_COLUMN_REQUEST",
    ADD_COLUMN_SUCCESS : "ADD_COLUMN_SUCCESS",
    ADD_COLUMN_FAILURE : "ADD_COLUMN_FAILURE",
    CLEAR_COLUMN_ADD_TRACKER : "CLEAR_ADD_COLUMN_TRACKER",

    CLEAR_LOADSTATUS: 'CLEAR_LOADSTATUS',
    BULK_EDIT_REQUEST: 'BULK_EDIT_REQUEST',
    BULK_EDIT_SUCCESS: 'BULK_EDIT_SUCCESS',
    BULK_EDIT_FAILURE: 'BULK_EDIT_FAILURE',

    GET_DEFAULT_TYPE_FIELDS_VALUES_REQUEST: 'GET_DEFAULT_TYPE_FIELDS_VALUES_REQUEST',
    GET_DEFAULT_TYPE_FIELDS_VALUES_SUCCESS: 'GET_DEFAULT_TYPE_FIELDS_VALUES_SUCCESS',
    GET_DEFAULT_TYPE_FIELDS_VALUES_FAILURE: 'GET_DEFAULT_TYPE_FIELDS_VALUES_FAILURE',


};


export const allDsConstants = {
    LOAD_DSLIST_REQUEST: 'LOAD_DSLIST_REQUEST',
    LOAD_DSLIST_SUCCESS: 'LOAD_DSLIST_SUCCESS',
    LOAD_DSLIST_FAILURE: 'LOAD_DSLIST_FAILURE',

    SEEKING_DELETE_CONFIRM: 'SEEKING_DELETE_CONFIRM',
    
    DELETE_DS_REQUEST: 'DELETE_DS_REQUEST',
    DELETE_DS_SUCCESS: 'DELETE_DS_SUCCESS',
    DELETE_DS_FAILURE: 'DELETE_DS_FAILURE'
};

